import BackButton from "../utils/backButton";
import Avatars from "./avatars";
import Colors from "./colors";
import { GetGlobalColor } from "../utils/globalColors";
import GameInfo from "./gameInfo";

const Extras = () => {
  const color = GetGlobalColor();

  return (
    <div className={`app-bg-${color} bg-overwrite`}>
      <BackButton to="/game" />
      <GameInfo />
      <Avatars />
      <Colors />
    </div >
  )
}

export default Extras;

